import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-down\"><path d=\"m10.519 12.926 3.309-3.782A.69.69 0 0 0 13.308 8H6.691a.69.69 0 0 0-.52 1.145l3.309 3.78a.69.69 0 0 0 1.039 0v.001Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol